




























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class FormConsentSection extends Vue {
  @Prop() form!: any;
  @Prop({ default: false }) formValid!: boolean;
  @Prop({ default: false }) saving!: boolean;
  @Prop({ default: () => [] }) dokterList!: any[];
  @Prop({ default: false }) isEdit!: boolean;
  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  valid = false;

  hubunganOptions = ["Diri sendiri", "Suami", "Istri", "Anak", "Ayah", "Ibu", "Lainnya"];

  get allConfirmed() {
    return this.form.konfirmasi_info_resusitasi
      && this.form.konfirmasi_manfaat_risiko
      && this.form.konfirmasi_tanggung_jawab;
  }
}
